"use client";

import { useTransition } from "react";
import { useRouter } from "next/navigation";

import { FUOCO_HOME, PULSANTE_SABBIA } from "@/components/home/stile";

/** «Riprova» dopo un errore a monte: rifà la stessa domanda senza
 *  ricaricare la pagina (`router.refresh`). */
export function RiprovaRullo() {
  const router = useRouter();
  const [inCorso, startTransition] = useTransition();
  return (
    <button
      type="button"
      disabled={inCorso}
      onClick={() => startTransition(() => router.refresh())}
      className={`${PULSANTE_SABBIA} cursor-pointer border-0 disabled:opacity-60 ${FUOCO_HOME}`}
    >
      {inCorso ? "Nuovo tentativo…" : "Riprova"}
    </button>
  );
}
